import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_category_list = (page, per_page) => {
  return api.post(`${ApiEndpointConstants.GETCATEGORYLIST}`, {
    page,
    per_page,
  });
};
